'use client';

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewPort } from '@/components/ui/toast';
import { useToast } from '@/hooks/use-toast';
export function Toaster() {
  const {
    toasts
  } = useToast();
  return <ToastProvider data-sentry-element="ToastProvider" data-sentry-component="Toaster" data-sentry-source-file="toaster.tsx">
      {toasts.map(function ({
      id,
      title,
      description,
      action,
      ...props
    }) {
      return <Toast key={id} {...props}>
            <div className="flex items-center gap-3">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>;
    })}
      <ToastViewPort data-sentry-element="ToastViewPort" data-sentry-source-file="toaster.tsx" />
    </ToastProvider>;
}